import { atom } from "recoil";

export const selectedClientHeader = atom ({
    key: "selectedClientHeader",
    default: 0,
});